<div class="tab-header" snAssistantSurface="oauthAppList" surfaceTitle="OAuth applications">
  <p-iconfield class="filter-field">
    <p-inputicon styleClass="pi pi-search" />
    <input
      pInputText
      type="text"
      i18n-placeholder="@@oauthApps.filter.name"
      placeholder="Filter by name"
      [(ngModel)]="nameFilter"
      (ngModelChange)="applyFilter()"
      snAssistantSkip />
  </p-iconfield>
  <p-button
    class="desktop-add-btn"
    i18n-label="@@oauthApps.newApplication"
    label="New Application"
    icon="pi pi-plus"
    (click)="newApplication()">
  </p-button>
</div>

<div class="table-section">
  <p-table
    [value]="filteredApplications()"
    [loading]="loading()"
    styleClass="oauth-apps-table">

    <ng-template pTemplate="header">
      <tr>
        <th i18n="@@oauthApps.col.name">Name</th>
        <th class="client-id-col" i18n="@@oauthApps.col.clientId">Client ID</th>
        <th class="redirects-col" i18n="@@oauthApps.col.redirectUris">Redirect URIs</th>
        <th class="actions-col" i18n="@@oauthApps.col.actions">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-app>
      <tr class="clickable-row" (click)="editApplication(app)">
        <td>{{ app.name || '-' }}</td>
        <td class="client-id-col">
          <div class="client-id-cell">
            <code>{{ app.client_id || '-' }}</code>
            @if (app.client_id) {
              <p-button
                icon="pi pi-copy"
                [text]="true"
                severity="secondary"
                size="small"
                i18n-pTooltip="@@common.copyToClipboard"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                (click)="copyClientId(app.client_id, $event)"
                i18n-ariaLabel="@@common.copyToClipboard"
                ariaLabel="Copy to clipboard">
              </p-button>
            }
          </div>
        </td>
        <td class="redirects-col">
          <div class="uri-tags">
            @for (uri of app.redirect_uris; track uri) {
              <span class="uri-tag" [pTooltip]="uri" tooltipPosition="top">{{ uri }}</span>
            }
            @if (!app.redirect_uris?.length) {
              <span class="muted">-</span>
            }
          </div>
        </td>
        <td class="actions-col">
          <div class="actions-buttons">
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              severity="secondary"
              size="small"
              i18n-pTooltip="@@common.edit"
              pTooltip="Edit"
              tooltipPosition="top"
              (click)="editApplication(app); $event.stopPropagation()"
              i18n-ariaLabel="@@common.edit"
              ariaLabel="Edit">
            </p-button>
            <p-button
              icon="pi pi-trash"
              [text]="true"
              severity="danger"
              size="small"
              i18n-pTooltip="@@common.delete"
              pTooltip="Delete"
              tooltipPosition="top"
              (click)="confirmDelete(app, $event)"
              [snAssistantAction]="'delete.' + app.id"
              [actionLabel]="'Delete ' + app.name"
              actionDangerous
              actionHint="Deletes the application. Every integration using its client id stops working at once."
              i18n-ariaLabel="@@common.delete"
              ariaLabel="Delete">
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="empty-message" i18n="@@oauthApps.empty">
          No OAuth applications yet
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="mobile-bottom-bar">
  <p-button
    i18n-label="@@oauthApps.newApplication"
    label="New Application"
    icon="pi pi-plus"
    (click)="newApplication()">
  </p-button>
</div>

<app-delete-confirmation
  [(visible)]="deleteDialogVisible"
  [title]="deleteTitle"
  [subtitle]="deleteSubtitle"
  [deleting]="isDeleting"
  (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()">
</app-delete-confirmation>
